import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const EmailManager = ({ handleInputChange, currentEmails, isBulkMode = false }) => {
  const [email, setEmail] = useState("");
  const [emailList, setEmailList] = useState(currentEmails);
  const [emailToString, setEmailToString] = useState("");

  const addMailFunction = async () => {
    const { value: email } = await Swal.fire({
      title: "Enter email address",
      input: "email",
      inputPlaceholder: "Enter a valid email address",
    });
    if (email) {
      setEmailList([...emailList, email]);
      setEmail("");
      handleInputChange([...emailList, email]);
    }
  };

  const saveEmailsToString = async () => {
    const emailString = emailList.join("; ");
    setEmailToString(emailString);
  };

  const removeEmail = async (emailToRemove) => {
    const modifiedList = emailList.filter((email) => email !== emailToRemove);
    setEmailList(modifiedList);
    handleInputChange(modifiedList);
  };

  return (
    <div>
      <div
        className="flex-container-display-email-blocks"
        style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
      >
        {emailList.map((email, index) => {
          // Extract the part of the email before @
          // const emailWithoutDomain = email.split('@')[0];

          return (
            <div key={index} className='flex-item-display-email-blocks-in-line tooltip-email' style={{ margin: '2px' }}>
              <span style={{ padding: '4px', border: '1px solid #ccc', borderRadius: '5px'}}>
                {/* {emailWithoutDomain}  */}
                {email}
                <button
                  onClick={() => removeEmail(email)}
                  style={{
                    color: "grey",
                    background: "none",
                    padding: "4px 0px 0px 3px",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    outline: "none",
                  }}
                >
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </span>
              {/* <span className='tooltip-text'>{email}</span> */}
            </div>
          );
        })}
        {isBulkMode ? (<></>) : (
          <div className='add-new-email-button tooltip-count' style={{ marginBottom: '5px' }}>
            <button 
              onClick={() => addMailFunction()}
              style={{
                background: "none",
                border: "none",
                outline: "none",
                padding: "5px 0px 0px 0px",
                outline: "none",
              }}
            >
              <i
                className="fa-solid fa-circle-plus"
                style={{
                  color: "darkslategrey",
                }}
              ></i>
            </button>
            <span className="tooltip-text">Add new mail</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailManager;
